import { format } from "date-fns";
import DocumentWorkspaceViewer, {
    DocumentWorkspaceNavigation,
} from "../../../../components/DocumentWorkspaceViewer/DocumentWorkspaceViewer";
import { useFetchFormDocument } from "../../hooks/client-forms.queries";
import {
    IAttendeeConsentFormRecord,
    IConsentFormRecord,
    IFormDocument,
} from "../../types/client-forms.types";

interface ConsentDocumentViewerProps {
    consent: IConsentFormRecord | IAttendeeConsentFormRecord;
    document: IFormDocument;
    navigation?: DocumentWorkspaceNavigation;
    onDownload?: () => void;
    isDownloading?: boolean;
}

const formatTimestamp = (value?: string | null) => {
    if (!value) return "Not recorded";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "Not recorded";
    return format(date, "MMM d, yyyy 'at' h:mm a");
};

export default function ConsentDocumentViewer({
    consent,
    document,
    navigation,
    onDownload,
    isDownloading,
}: ConsentDocumentViewerProps) {
    const { data, error, isLoading } = useFetchFormDocument(
        document.document_url,
        Boolean(document.document_url)
    );
    const isGeneratedConsent = document.document_type === "generated_consent";
    const signedAt = consent.client_submitted_at ?? consent.signed_date;
    const documentDate = isGeneratedConsent ? signedAt : document.uploaded_at;

    return (
        <DocumentWorkspaceViewer
            documentKey={document.document_id}
            data={data?.data}
            contentType={data?.content_type ?? document.content_type}
            isLoading={isLoading}
            isError={Boolean(error)}
            title={document.document_name}
            subtitle={`${isGeneratedConsent ? "Signed" : "Uploaded"} ${formatTimestamp(
                documentDate
            )}`}
            badge={
                <span className="shrink-0 rounded-full bg-[#E8F7F1] px-8 py-2 text-[10px] font-semibold text-[#087A55]">
                    {isGeneratedConsent
                        ? "E-signed consent"
                        : "Uploaded attachment"}
                </span>
            }
            navigation={navigation}
            onDownload={onDownload}
            isDownloading={isDownloading}
        />
    );
}
